export const SITE_ORIGIN = "https://primuslabs.xyz";
export const SITE_NAME = "Primus";
export const DEFAULT_IMAGE = `${SITE_ORIGIN}/poster.png`;
export const DEFAULT_IMAGE_ALT =
  "Primus, confidential infrastructure for institutional onchain finance";

const ORGANIZATION_ID = `${SITE_ORIGIN}/#organization`;
const WEBSITE_ID = `${SITE_ORIGIN}/#website`;

export const SEO_PAGES = {
  "/": {
    title: "Primus | Confidential Infra for Institutional Onchain Finance",
    description:
      "Primus builds a confidential infrastructure for on-chain finance, combining verifiable data access with privacy-preserving computation.",
    changefreq: "weekly",
    priority: "1.0",
  },
  "/por": {
    title: "Proof of Reserves (PoR) | Primus",
    description:
      "Primus PoR solution enables institutions to securely aggregate and verify on-chain and off-chain reserves, continuously presenting real-time financial positions with cryptographic certainty.",
    changefreq: "weekly",
    priority: "0.9",
  },
  "/data-verification": {
    title: "Data Verification | Primus",
    description:
      "Primus Data Verification solution leverages zkTLS to cryptographically prove and attest any web data or user actions with full privacy for smart contracts and applications.",
    changefreq: "monthly",
    priority: "0.8",
  },
};

export function normalizePath(pathname) {
  if (!pathname || pathname === "/") return "/";
  return pathname.replace(/\/+$/, "") || "/";
}

export function pageUrl(path) {
  return path === "/" ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${path}`;
}

export function buildJsonLd(path, page) {
  const url = pageUrl(path);

  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": ORGANIZATION_ID,
        name: SITE_NAME,
        url: SITE_ORIGIN,
        logo: {
          "@type": "ImageObject",
          url: `${SITE_ORIGIN}/logo192.png`,
        },
        sameAs: [
          "https://x.com/primus_labs",
          "https://github.com/primus-labs",
          "https://discord.com/invite/pdrNxRrApX",
          "https://medium.com/@primuslabs",
        ],
      },
      {
        "@type": "WebSite",
        "@id": WEBSITE_ID,
        name: SITE_NAME,
        url: SITE_ORIGIN,
        publisher: { "@id": ORGANIZATION_ID },
      },
      {
        "@type": "WebPage",
        "@id": `${url}#webpage`,
        url,
        name: page.title,
        description: page.description,
        isPartOf: { "@id": WEBSITE_ID },
        about: { "@id": ORGANIZATION_ID },
        primaryImageOfPage: {
          "@type": "ImageObject",
          url: DEFAULT_IMAGE,
        },
      },
    ],
  };
}
